import type { MarkupColumnTypes } from "@btnet/services-btnet/handlers/models/markupColumnTypes";

import { type CostTypes, type MarkedAs } from "types/enum";

import { type ILineItemPrintTableEntity } from "commonComponents/entity/lineItem/LineItemContainerPrintTable/LineItemContainerPrintTable.types";

export class LineItemPrintEntity implements ILineItemPrintTableEntity {
    constructor(data: any, key: number) {
        this.key = data.id !== undefined ? data.id : key;
        this.builderId = data.builderId;
        this.entityId = data.entityId;
        this.costCodeId = data.costCodeId;
        this.costCodeTitle = data.costCodeTitle;
        this.title = data.title;
        this.description = data.description;
        this.quantity = data.quantity;
        this.unitType = data.unitType;
        this.unitCost = data.unitCost;
        this.unitPrice = data.unitPrice;
        this.ownerPrice = data.ownerPrice;
        this.amountPaid = data.amountPaid;
        this.isFooter = data.isFooter || false;
        this.costTypes = data.costTypes ?? [];
        this.markedAs = data.markedAs;
        this.totalWithTax = data.totalWithTax;
        this.taxGroupId = data.taxGroupId;
        this.totalEffectiveRate = data.totalEffectiveRate;
        this.markupPercentage = data.markupPercentage;
        this.markupAmount = data.markupAmount;
        this.markupColumn = data.markupColumn;
        this.markupPerUnit = data.markupPerUnit;
        this.builderCost = data.builderCost;
        this.isStackedLineItem = data.isStackedLineItem;
    }

    key: number;
    builderId: number;
    entityId: number;
    costCodeId: number;
    costCodeTitle: string;
    title: string;
    description: string;
    quantity?: number | null;
    unitType: string;
    unitCost?: number | null;
    unitPrice?: number | null;
    ownerPrice?: number;
    amountPaid?: number;
    isFooter: boolean;
    costTypes: CostTypes[];
    markedAs?: MarkedAs;
    totalWithTax?: number;
    taxGroupId?: number;
    totalEffectiveRate?: number;
    markupPercentage?: number;
    markupAmount?: number;
    markupColumn?: MarkupColumnTypes;
    markupPerUnit?: number;
    builderCost?: number;
    isStackedLineItem?: boolean;
    isGroupHeader?: boolean;
    taxGroupHeader?: string;
}

export class LineItemPrintContainerEntity {
    constructor(data: any) {
        this.lineItems = data.map((li: any, i: number) => new LineItemPrintEntity(li, i));
    }

    lineItems: LineItemPrintEntity[];
}
